import { useState } from 'react';
import { getNewRecoveryKey } from 'src/shared/services/idaas/user';
import { ConfirmationModal } from './ConfirmationModal';
import { formatKeyValue } from '../TwoFactorAuthentication.service';

interface GenerateKeyModalProps {
  visible: boolean;
  hideGenerateKeyModal: () => void;
  showToast: (message: string, severity: 'success' | 'error') => void;
}

const GenerateKeyModal: React.FC<GenerateKeyModalProps> = ({ visible, hideGenerateKeyModal, showToast }) => {
  const [generatedKey, setGeneratedKey] = useState<string | undefined>(undefined);

  const generateKey = async () => {
    const response = await getNewRecoveryKey();
    setGeneratedKey(response?.emergencyRecoveryKey);
    console.log('Generated Key:', response?.emergencyRecoveryKey);
    showToast('Key generated successfully', 'success');
  };

  const copyKey = async () => {
    await navigator.clipboard
      .writeText(generatedKey || '')
      .then(() => {
        showToast(`Copied : ${formatKeyValue(generatedKey)}`, 'success');
      })
      .catch((error) => {
        console.error(error);
        showToast('Copy unsuccessful, please try again', 'error');
      });
    setGeneratedKey(undefined);
    hideGenerateKeyModal();
  };

  return (
    <>
      <ConfirmationModal
        title="Generating a new recovery key"
        confirmMessage="Are you sure you want to generate a new key?"
        infoText="Copy to Clipboard"
        confirmText="YES"
        onCancel={hideGenerateKeyModal}
        onConfirm={generateKey}
        showKey={!!generatedKey}
        keyValue={generatedKey}
        onInfo={copyKey}
        visible={visible}
      />
    </>
  );
};

export default GenerateKeyModal;
